/* istanbul ignore file */
import { boolean as codecBoolean, oneOf as codecOneOf, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { PatchAllowRegistrationDomainData } from './PatchAllowRegistrationDomainData';
import { PatchBlockRegistrationDomainData } from './PatchBlockRegistrationDomainData';
const PatchRegistrationDomainDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    /* #__PURE__ */ parsers.taggedUnion('type', [
        ['allow', PatchAllowRegistrationDomainData],
        ['block', PatchBlockRegistrationDomainData],
    ]),
    /* #__PURE__ */ parsers.object([
        ['domain', /* #__PURE__ */ codecOptional(codecString)],
        [
            'matchSubdomains',
            /* #__PURE__ */ codecOptional(codecBoolean),
            'match_subdomains',
        ],
    ]),
]);
export const PatchRegistrationDomainData = PatchRegistrationDomainDataParser;
